import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import {
    InputGroup, SideCancelBtn, SubmitBtn, ActionSection,
    ScrollableContent,
    Wrapper,
    FieldWrappers,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import { Formik, Form, Field, ErrorMessage } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import * as Yup from "yup";
import { toast } from "react-toastify";
import DropZone from "../Notice/Dropzone";
import { useSelector } from "react-redux";
import axios from "axios";
import { useQuery } from "react-query";
import Config from "../../Config";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "../SinglePropSelectModal";
import SelectOptionModal from "../SelectOptionModal";
import SelectItemModal from "../SelectItemModal";
import { complaintCategories } from "../../helpers";

const AddComplaint = ({
    key,
    addComplaintMutate,
    addComplaintLoading,
    handleClose
}) => {
    const [isProblemModalOpen, setIsProblemModalOpen] = useState(false);
    const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const user = useSelector((state) => state.UserReducer.user);
    const selProperty = useSelector((state) => state.SelectPropertyReducer.selectProperty);
    const propertyList = useSelector((state) => state.PropertyReducer.property);
    const propId = selProperty.id;
    const formikRef = useRef(null);
    const [selectedType, setSelectedType] = useState("");
    const [filter, setFilter] = useState("");
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [selectedProperty, setSelectedProperty] = useState(null);

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [key]);

    const initialValues = {
        problem: "",
        problemDescription: "",
        media: "",
        tenant: "",
        type: "",
        property: propId || "", // Initialize with the currently selected property
    };

    const type = [
        { value: 1, label: "Tenant" },
        { value: 2, label: "Property" },
    ];

    // const problem = [
    //     { value: "Emergency Issues", label: "Emergency Issues" },
    //     { value: "Wi-Fi/Internet Issue", label: "Wi-Fi/Internet Issue" },
    //     { value: "Electronics/Appliance Issue", label: "Electronics/Appliance Issue" },
    //     { value: "Maintenance and infrastructure", label: "Maintenance and infrastructure" },
    //     { value: "Plumbing Issues", label: "Plumbing Issues" },
    //     { value: "AC Issue", label: "AC Issue" },
    //     { value: "Water Purifier Issue", label: "Water Purifier Issue" },
    //     { value: "Roommate and Co-Resident Issues", label: "Roommate and Co-Resident Issues" },
    //     { value: "Hygiene and Cleanliness", label: "Hygiene and Cleanliness" },
    //     { value: "Security and Privacy", label: "Security and Privacy" },
    //     { value: "Food and Meal", label: "Food and Meal" },
    //     { value: "Rent/Payment", label: "Rent/Payment" },
    //     { value: "Staff", label: "Staff" },
    //     { value: "Other", label: "Other" },
    // ];
    const problemOptions = complaintCategories.map(role => ({
        label: role.label,
        value: role.value,
    }));

    const handleSubmit = (values, { resetForm }) => {
        if (!values.type) {
            toast.error("The 'Raise Complaint for' field is required");
            return;
        }
        if (!values.problem) {
            toast.error("The 'What's Causing the Problem' field is required");
            return;
        }
        if (!values.problemDescription) {
            toast.error("The 'Describe the Problem' field is required");
            return;
        }
        if (values.type == 1) {
            if (!values.tenant) {
                toast.error("Tenant name is required for which complaint raised.");
                return;
            }
        }
        if (values.type == 2) {
            if (!values.property) {
                toast.error("Property selection is required for property complaint.");
                return;
            }
        }

        const formData = new FormData()
        formData.append("title", String(values.problem))
        formData.append("description", values.problemDescription)
        formData.append("id", values.type === 1 ? values.tenant : values.property)
        formData.append("type", values.type)
        if (values.media) {
            formData.append("file", values.media[0])
        }
        addComplaintMutate(formData);
        // addComplaintMutate({
        //     title: String(values.problem),
        //     description: values.problemDescription,
        //     id: values.type == 1 ? values.tenant : values.property,
        //     type: values.type,
        //     file: values.media
        // })
    };

    const query = `?propId=${propId}&searchVal=&filter=${filter}`;

    const fetchListing = async () =>
        await axios.get(`${Config.apiUrl}/tenant/list/web${query}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading, error, data, refetch, isRefetching } = useQuery(
        ['tenantData', propId],
        fetchListing,
        {
            enabled: false,
            retry: 1,
        }
    );

    useEffect(() => {
        if (selectedType == 1 && propId !== null && propId !== undefined) {
            refetch();
        }
    }, [selectedType, propId, refetch]);

    const tenant = data?.data?.data?.list;

    const filteredProperties = propertyList.filter(property => property.id !== 0);

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedOption.id)
        }
    }

    // Show loading when API is fetching
    const isTenantLoading = isLoading || isRefetching;

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Add Complaint</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={formikRef}
                >
                    {({ values, handleChange, setFieldValue }) => {
                        const getProblemLabel = () => {
                            const selectedRole = complaintCategories.find(role => role.value === values?.problem);
                            return selectedRole ? selectedRole.label : "Select problem";
                        };

                        const handleProblemSelect = (selectedValue) => {
                            setFieldValue("problem", selectedValue);
                        };
                        return (
                            <Form >
                                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                    <Wrapper>
                                        <InputGroup>
                                            <Label htmlFor="type">Raise Complaint for *</Label>
                                            <Select
                                                name="type"
                                                id="type"
                                                className="w-full pl-2"
                                                style={{ height: "46px" }}
                                                value={values.type}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setSelectedType(Number(e.target.value));
                                                }}
                                            >
                                                {type.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </InputGroup>

                                        {values.type == 1 && (
                                            <InputGroup>
                                                <Label htmlFor="tenant">Raise Complaint for Tenant *</Label>

                                                {/* Show loading state */}
                                                {isTenantLoading && (
                                                    <div className="flex items-center justify-center py-4">
                                                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                                                        <span className="ml-2 text-gray-600">Loading tenants...</span>
                                                    </div>
                                                )}

                                                {/* Show error state */}
                                                {error && !isTenantLoading && (
                                                    <div className="text-red-500 text-sm py-2 px-3 bg-red-50 rounded border border-red-200">
                                                        Failed to load tenants. Please try again.
                                                        <button
                                                            onClick={() => refetch()}
                                                            className="ml-2 text-blue-600 underline"
                                                        >
                                                            Retry
                                                        </button>
                                                    </div>
                                                )}

                                                {/* Show tenant dropdown only when data is available and no error */}
                                                {!isTenantLoading && !error && data && (
                                                    <CategoryCard
                                                        title="Tenant"
                                                        selectedCategory={selectedTenant}
                                                        onClick={() => setIsTenantModalOpen(true)}
                                                    />
                                                )}

                                                {/* Show message when no tenants found */}
                                                {!isTenantLoading && !error && data && (!tenant || tenant.length === 0) && (
                                                    <div className="text-gray-500 text-sm py-2 px-3 bg-gray-50 rounded border border-gray-200">
                                                        No tenants found for this property.
                                                    </div>
                                                )}
                                            </InputGroup>
                                        )}

                                        {values.type == 2 && filteredProperties && filteredProperties.length > 0 && (
                                            <InputGroup>
                                                <Label>Select property </Label>
                                                <CategoryCard
                                                    title="Property"
                                                    selectedCategory={selectedProperty}
                                                    onClick={() => setShowPropertyModal(true)}
                                                />
                                            </InputGroup>

                                        )}

                                        {/* Show other input fields only when tenant API is not loading or when type is not tenant */}
                                        {(!isTenantLoading || values.type !== 1) && (
                                            <>
                                                <InputGroup>
                                                    <Label htmlFor="problem">What's Causing the Problem *</Label>
                                                    <FieldWrappers onClick={() => setIsProblemModalOpen(true)}>
                                                        <Field
                                                            type="text"
                                                            name="problem"
                                                            id="problem"
                                                            autoComplete="off"
                                                            readOnly
                                                            value={getProblemLabel()}
                                                            className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                        />
                                                        <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />

                                                    </FieldWrappers>

                                                </InputGroup>

                                                <InputGroup>
                                                    <Label htmlFor="problemDescription">Describe the Problem *</Label>
                                                    <FieldWrapper>
                                                        <Field
                                                            as={Textarea}
                                                            id="problemDescription"
                                                            name="problemDescription"
                                                            rows={4}
                                                            maxLength={500}
                                                            placeholder="Write your problem here..."
                                                        />
                                                    </FieldWrapper>
                                                </InputGroup>

                                                <InputGroup>
                                                    <Label htmlFor="media">
                                                        Upload images for references
                                                    </Label>
                                                    <FieldWrapper $select={true}>
                                                        <Field
                                                            required
                                                            name="media"
                                                            type="text"
                                                            id="media"
                                                            autoComplete="off"
                                                        >
                                                            {(props) => (
                                                                <DropZone
                                                                    fields={props.field}
                                                                    setFieldValue={props.form.setFieldValue}
                                                                    componentFor="profile"
                                                                    acceptFiles="application/image"
                                                                    File={props.field.value ? [props.field.value] : null}
                                                                />
                                                            )}
                                                        </Field>
                                                    </FieldWrapper>
                                                    <p className="text-xs text-gray-500 mt-2">Image max size: 10MB</p>
                                                </InputGroup>
                                            </>
                                        )}
                                    </Wrapper>
                                </ScrollableContent>
                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn
                                        type="submit"
                                        disabled={addComplaintLoading || (values.type === 1 && isTenantLoading)}
                                    >
                                        {addComplaintLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>
                                <SinglePropSelectModal
                                    isOpen={showPropertyModal}
                                    onClose={() => setShowPropertyModal(false)}
                                    onSelect={handleSelectedProperty}
                                    options={propertyList}
                                    selectedProperty={selectedProperty}
                                />
                                <SelectOptionModal
                                    isOpen={isProblemModalOpen}
                                    onClose={() => setIsProblemModalOpen(false)}
                                    title="Select Problem"
                                    options={problemOptions}
                                    selectedValue={values.problem}
                                    onSelect={handleProblemSelect}
                                    searchPlaceholder="Search problem..."
                                />
                                <SelectItemModal
                                    isOpen={isTenantModalOpen}
                                    onClose={() => setIsTenantModalOpen(false)}
                                    onSelect={(tenant) => {
                                        if (tenant) {
                                            setFieldValue("tenant", tenant.tenantId);
                                            setSelectedTenant(tenant);
                                        } else {
                                            // Handle clear selection
                                            setFieldValue("tenant", "");
                                            setSelectedTenant(null);
                                        }
                                    }}
                                    options={tenant || []}
                                    selectedItem={selectedTenant}
                                    title="Select Tenant"
                                    searchPlaceholder="Search tenants..."
                                    idKey="tenantId"
                                    nameKey="name"
                                    descriptionKeys={["roomNum", ["floor", "flatName"], "propertyName"]}
                                    emptyMessage="No tenants available"
                                    noResultsMessage="No tenants found"
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </Container>
    );
};

const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const FieldWrapper = tw.div`w-full`;
const Label = tw.label`text-sm text-gray-500 font-normal `;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const DropHeader = tw.div`flex justify-between items-start mb-1`
const Name = tw.div`text-gray-800 text-md`;
const Details = tw.div`flex items-center justify-between text-sm text-gray-600`
const Role = tw.div`text-sm text-primary-color`;

export default AddComplaint;